import React, { Component } from 'react';
import '../../_Content/css/modulo-efd.css';

class ModuloEfd extends Component {

	constructor(props) {
		super(props);

		this.state = {
			checked: true
		};
	}

	mostrarModulo() {
		var texto, classe, abreviacao;

		switch (this.props.value) {
			case 'ECF':
				texto = 'ECF';
				classe = 'ECF';
				abreviacao = 'E';
				break;
			case 'ECD':
				texto = 'ECD';
				classe = 'ECD';
				abreviacao = 'ECD';
				break;
			case 'Fiscal':
				texto = 'Fiscal';
				classe = 'fiscal';
				abreviacao = 'F';
				break;
			case 'SimplesNacional':
				texto = 'Simples Nacional';
				classe = 'simples-nacional';
				abreviacao = 'SN';
				break;
			default:
				texto = 'Contribuições';
				classe = 'contribuicao';
				abreviacao = 'C';
		}

		return (
			<a className="modBtn" onClick={this.toggle}>
				<label className={this.state.checked ? classe : 'unchecked'}>{abreviacao}</label>
				<span>{texto}</span>
				{/* {texto == "ECF" ? <span class="badge badge-danger betaEcf">BETA</span> : "" }				 */}
			</a>
		);
	}

	toggle = () => {
		if (this.props.checkable)
			this.setState({ checked: !this.state.checked }, this.updated);
	}

	justCheck = () => {
		this.setState({ checked: true });
	}

	updated = () => {
		if (this.props.onUpdate)
			this.props.onUpdate(this.props.value, this.state.checked);
	}

	render() {
		return (
			<div className="modulo-efd">
				{this.mostrarModulo()}
			</div>
		);
	}
}

export default ModuloEfd;



// WEBPACK FOOTER //
// ./src/Componente/Modulo/ModuloEfd.jsx